import { render, staticRenderFns } from "./AddWebsite.vue?vue&type=template&id=3bc535a4"
import script from "./AddWebsite.vue?vue&type=script&lang=ts"
export * from "./AddWebsite.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports